<template>
  <div>
    <div class="row">
      <!-- <div class="col-md-3" id="solicitacoes">
        <router-link to="/solicitacoes" style="color: #82868b">
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                <feather-icon size="21" :icon="'HeartIcon'" />
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.solicitations }}
                </h2>
                <span>Solicitações Cadastradas</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div>
      <div class="col-md-3" id="aprovacoes">
        <router-link to="/aprovacoes" style="color: #82868b">
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-danger`" size="45">
                <feather-icon size="21" :icon="'CheckSquareIcon'" />
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.in_approve }}
                </h2>
                <span>Aguardando Aprovação</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div>
      <div class="col-md-3" id="programacoes">
        <router-link to="/programacoes" style="color: #82868b">
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-primary`" size="45">
                <feather-icon size="21" :icon="'CalendarIcon'" />
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.waiting_programming }}
                </h2>
                <span>Aguardando Programação</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div>
      <div class="col-md-3" id="usuarios">
        <router-link to="/programacoes" style="color: #82868b">
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-success`" size="45">
                <i class="fas fa-check" style="font-size: 21px"></i>
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.solicitations_f }}
                </h2>
                <span>Solicitações Finalizadas</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div>
      <div class="col-md-3" id="usuarios">
        <router-link to="/users" style="color: #82868b">
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-success`" size="45">
                <feather-icon size="21" :icon="'UsersIcon'" />
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.users }}
                </h2>
                <span>Usuários Cadastrados</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div> -->
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      team_id: 1,
      changed_team_id: 1,
      teams: [],
      connected: 0,
      received: {
        message: 0,
      },
    };
  },
  components: {},
  methods: {
    getDashboard() {
      const self = this;
      const api = self.$store.state.api + "teams";

      axios
        .get(api)
        .then((response) => {
          self.teams = response.data.data;

          if (self.teams.length > 0) {
            self.team_id = self.teams[0].id_cr_samu;
            self.changed_team_id = self.teams[0].id_cr_samu;
            self.getWebSocket();
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    change_team() {
      const self = this;
      Echo.leave("nova-ocorrencia." + self.team_id);
      self.connected = 0;
      self.received = {
        message: 0,
      };
      setTimeout(() => {
        self.team_id = self.changed_team_id;
        self.getWebSocket();
      }, 100);
    },
    getWebSocket() {
      const self = this;
      setTimeout(() => {
        self.connected = 1;
      }, 1000);
      setTimeout(() => {
        Echo.private("nova-ocorrencia." + self.team_id).listen(
          ".NovaOcorrencia",
          (data) => {
            var data = JSON.parse(data.message);
            console.log(data);
            self.received = data;
          }
        );
        self.connected = 2;
      }, 2000);
    },
  },
  destroyed() {},
  mounted() {
    const self = this;

    // self.getDashboard();

    // let intervl = 0;

    // setTimeout(function () {
    //   while (intervl < 1000) {
    //     clearInterval(intervl);
    //     console.log("limpando intervals");
    //     intervl++;
    //   }
    // }, 1000);

    // if (self.interval == "") {
    //   self.interval = setInterval(function () {
    //     self.getDashboard();
    //   }, 10000);
    // }

    // Echo.private("user.1").listen(".Alert", (data) => {
    //   console.log(data);
    // });
  },
  created() {},
};
</script>

<style></style>
